module.exports = __webpack_public_path__ + "html/feedback-slider_dfe3bd5bd8b376c1575256d5579b55ea.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/feedback-slider.html
// module id = Zm8k
// module chunks = 4